import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useNavigation, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import goalsImg from '../assets/images/home1.jpg';
import statsImg from '../assets/images/stats1.jpg';
import friendsImg from '../assets/images/friends.png';
import appStoreDownload from "../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
import googlePlayDownload from "../assets/images/GetItOnGooglePlay_Badge_Web_color_English.svg"
import "./LandingPage.css"

function LandingPage() {
    const {userId, token} = useParams();
    const {verify, testGbug} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams()
    const [prompt, setPrompt] = useState<any>();

    const setEvent = (e: any) =>{
         //-- console.log(e);
        e.preventDefault();
        setPrompt(e);
    }
    useEffect(()=>{
       //  //-- console.log("landing mounting")
        // //-- console.log("hello landing", location, params)
        window.addEventListener("beforeinstallprompt",setEvent);
        return ()=>{
            window.removeEventListener("beforeinstallpropmpt", setEvent)
        }
    },[])
    const handleDownload = async () =>{
        if(prompt) {
            await prompt.prompt()
        }
        else {
            navigate("/download")
        }
    }
    return (
        
        <div id='landing-page'>
            <div id='cropping'>

          
        <section id='set-goal'>
            <div className='text'>
                <h1>Set your goal</h1>
                <p>stay motivated, work hard and you will achieve it!</p>
                <div className='buttons'>
                 <Link to={"/register"}><button>sign up</button></Link>
                 <Link to={"/login"} ><button className='outline'>login</button></Link>
                 </div>
                 <p style={{fontStyle: "italic"}}>- It's free! -</p>
                
            </div>
            
            <img src={goalsImg} alt='goals screenshot' className='app-screenshot1' />
        </section>
        <section id='track-progress'>
              <img src={statsImg} alt='goals screenshot' className='app-screenshot2' />
            <div className='text'>
              
                <h1>Track your progress</h1>
                <p>get detailed stats of your goal over time!</p>
                <div className='buttons'>
                    <Link to={"/register"}><button className='outline'>Start now</button></Link>
                </div>
                   
            </div>
            

        </section>
        <section id='share-friends'>
            <div className='text'>
                <h1>Share with friends</h1>
                <p>Share your progress with your friends, and follow them back!</p>
                <div className='buttons'>
                     {/* {<button onClick={() => prompt.prompt()}>download</button>} */}
                    <Link to={"/register"}><button className='outline'>Join for Free</button></Link>
                </div>
            </div>
            
            <img src={friendsImg} alt='goals screenshot' className='app-screenshot3' />
        </section>
         </div>
        
        </div>
    );
}

export default LandingPage;
